import { isUnifiedEventObjectTypeId } from '../../../filterQueryFormat/ObjectTypeId';
import Adapter from './Adapter';
import HttpAdapterConfig from '../adapterConfigs/HttpAdapterConfig';
import UnifiedEventsAdapter from './UnifiedEventsAdapter';
import { Map as ImmutableMap } from 'immutable';
import { formatUnifiedEventProperties } from '../utils/unifiedEventPropertiesUtils';
export class UnifiedEventPropertiesAdapterConfig extends HttpAdapterConfig {
  constructor(...args) {
    super(...args);
    this.performanceTrackingKey = 'UnifiedEventPropertiesAdapter';
  }
  getCacheKey(assetFamily) {
    return `UNIFIED_EVENT_PROPERTIES_${assetFamily}`;
  }
  isAssetFamilySupported(assetFamily) {
    return isUnifiedEventObjectTypeId(assetFamily);
  }
  fetchData(httpClient, assetFamily, __variables) {
    return UnifiedEventsAdapter.getFetchedData(assetFamily).then(result => UnifiedEventsAdapter.getFormattedData(assetFamily, result, ImmutableMap())).then(unifiedEvents => {
      const unifiedEvent = unifiedEvents.get(assetFamily);
      if (unifiedEvent) {
        const fullyQualifiedName = unifiedEvent.fullyQualifiedName;
        return Promise.all([httpClient(`framework-builder/v1/read/metadata/property/${fullyQualifiedName}/filtersFrontEnd`), httpClient(`properties/v4/${fullyQualifiedName}`)]);
      }
      return Promise.reject(new Error(`No fullyQualifiedName found for ${assetFamily}`));
    });
  }
  formatData(response, assetFamily) {
    return formatUnifiedEventProperties(response, assetFamily);
  }
}
export default Adapter.makeFromConfig(UnifiedEventPropertiesAdapterConfig);